import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@fluentui/react/lib/Icon'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { useViewport } from '../../utils'
import { useInternationalization } from '../../features/i18n'

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const PartnerAvatar = ({image}) => {
  return (
    <div
      style={{
        width: '24px',
        height: '24px',
        backgroundColor: '#fff',
        backgroundImage: `url('${image}')`,
        backgroundSize: '70%'
      }}
      className="rounded-full bg-center mr-2 bg-no-repeat shadow"
    />
  )
}

const TableRow = ({
  data,
  onDelete,
  noEdit,
  onEdit,
  editPath = `/dashboard/organization/profile/partners/form/`,
}) => {
  const { isDesktop } = useViewport();
  const [open, setOpen] = React.useState(false);
  const { translate } = useInternationalization()

  const actionButtonClasses =
    "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5";
  const actionButtonStyles = {
    minWidth: "67px",
  };

  const { pkId, name, image, website = "-" } = data;

  const editLink = `${editPath}${pkId}`;

  return (
    <tr>
      <td width="40%">
        <div className="flex lg:items-center py-4 lg:py-0">
          <PartnerAvatar image={image} />
          <div>
            <div>{name}</div>
            {!isDesktop && <div>
              <a href={website} target="_blank" rel="noopener noreferrer">
                {website}
              </a>
            </div>}
          </div>
        </div>
      </td>
      {isDesktop && <td width="40%">
        <a href={website} target="_blank" rel="noopener noreferrer">
          {website}
        </a>
      </td>}
      <td className="relative">
        {isDesktop && (
          <div className="flex items-center justify-end pr-1">
            {!noEdit && (
              <p className="cursor-pointer underline text-sm text-primary mr-8">
                {
                  onEdit ? (
                    <span onClick={onEdit}>Edit</span>
                  ) : (
                    <Link to={editLink}>Edit</Link>
                  )
                }
              </p>
            )}
            {
              onDelete &&
              <p
                className="cursor-pointer underline text-sm text-gray-999"
                onClick={onDelete}
              >
                {translate('GENERAL', 'delete')}
              </p>
            }
          </div>
        )}
        {!isDesktop && !noEdit && <ChevronLeft onClick={() => setOpen(true)} />}
        {open && (
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{
                width: "183px",
                background:
                  "linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)",
              }}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            {!noEdit && (
              <Link
                className={`bg-primary ${actionButtonClasses}`}
                style={{ ...actionButtonStyles }}
                to={editLink}
              >
                <Edit />
                <p className="underline mt-2">Edit</p>
              </Link>
            )}
            {
              onDelete &&
              <div
                className={`${actionButtonClasses}`}
                style={{ background: "#999", ...actionButtonStyles }}
                onClick={onDelete}
              >
                <Delete />
                <p className="underline mt-2">
                  {translate('GENERAL', 'delete')}
                </p>
              </div>
            }
          </div>
        )}
      </td>
    </tr>
  );
};

export { TableRow }
